import yup, { cardNameValidator, arrayValidator, stringValidator, statusValidator } from '~/utils/validators.yup';

export const schema = () =>
    yup.object({
        name: cardNameValidator(),
        description: stringValidator.max(300).required(),
        adventureCategoryId: yup.mixed('*required').required(),

        addonDvList: arrayValidator,
        minDvList: arrayValidator,
        maxDvList: arrayValidator,
        addonPointList: arrayValidator,

        addonMaxHpList: arrayValidator,
        addonRegenHpList: arrayValidator,
        opponentAddonMaxHpList: arrayValidator,
        opponentAddonRegenHpList: arrayValidator,

        bonusHpmList: arrayValidator,
        bonusHwatList: arrayValidator,
        damageCapList: arrayValidator,

        activeRounds: arrayValidator.min(1, 'at lease one must be checked.'),
        activeTurns: arrayValidator.min(1, 'at lease one must be checked.'),

        effects: statusValidator,
    });
